import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FirebaseListObservable, AngularFireDatabase } from 'angularfire2/database-deprecated';
import { NgModel } from '@angular/forms';
import { UserService } from '../../_services/user.service';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { Subscription } from 'rxjs';
import { ApiService } from '../../_services/api.service';
import { AngularFirestore } from 'angularfire2/firestore';
import { Http } from '@angular/http';
@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.css']
})
export class PersonalInfoComponent implements OnInit, OnDestroy {
  user: any = {};
  lastUser;
  updateModel: any = {};
  userId: any;
  message: any;
  confirmation: any;
  recaptcha = true;
  ipAddress: any;
  phoneMesLenErr = false;
  editPhoneButton = false;
  phoneMesErr = false;
  jobs: any[] = environment.jobs;
  turkeyCities: FirebaseListObservable<any>;
  public mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  days = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15',
    '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
  months = [
    { month: 'Ocak', value: '01' },
    { month: 'Şubat', value: '02' },
    { month: 'Mart', value: '03' },
    { month: 'Nisan', value: '04' },
    { month: 'Mayıs', value: '05' },
    { month: 'Haziran', value: '06' },
    { month: 'Temmmuz', value: '07' },
    { month: 'Ağustos', value: '08' },
    { month: 'Eylül', value: '09' },
    { month: 'Ekim', value: '10' },
    { month: 'Kasım', value: '11' },
    { month: 'Aralık', value: '12' }];
  years = [];
  @ViewChild('username') public username: NgModel;
  private subscription: Subscription = new Subscription();

  constructor(
    private afs: AngularFirestore,
    private userService: UserService,
    private apiService: ApiService,
    private _http: Http,
    private router: Router,
    private dialog: MatDialog) {

    let dateNow = new Date();
    let currentYear = dateNow.getFullYear();
    this.getIpAdress();
    for (let i = currentYear - 100; i < currentYear; i++) {
      this.years.push(i);
    }

    this.userId = this.userService.getUid();
    this.subscription.add(this.userService.getUser().subscribe(snap => {
      this.user = snap;
      if (snap) {
        this.updateModel.username = snap.username;
        this.updateModel.day = snap.birthday ? snap.birthday.day : 'Gün';
        this.updateModel.year = snap.birthday ? snap.birthday.year : 'Yıl';
        this.updateModel.month = snap.birthday ? snap.birthday.month : 'Ay';
        this.updateModel.firstname = snap.firstname;
        this.updateModel.lastname = snap.lastname;
        this.updateModel.email = snap.email;
        this.updateModel.about = snap.about;
        this.updateModel.job = snap.job ? snap.job : 'Meslek Seçin';
        this.updateModel.phoneNumber = snap.phoneNumber;
        this.updateModel.gender = snap.gender ? snap.gender : 'Cinsiyet Seçin';
        this.updateModel.city = snap.city ? snap.city : 'Şehir Seçin';
        this.updateModel.education = snap.education ? snap.education : 'Eğitim Durumu';
      }
    }));

    // this.turkeyCities = afm.list('/countries/turkey');
  }

  navigate() {

    let phoneNum = this.updateModel.phoneNumber.replace('(', '').replace(/\s/g, '').replace(/\_/g, '').replace(')', '').replace('-', '');
    if (phoneNum && phoneNum.length == 10 && phoneNum != this.user.phoneNumber) {
      this.onSubmit("phone");
      this.router.navigate(['profile-update/phone-update'], { queryParams: { phone: phoneNum } });
    } else if (!phoneNum) {
      this.phoneMesErr = true;
    } else if (phoneNum.length != 10) {
      this.phoneMesLenErr = true;
    }
  }

  onlyNumberKey(event) {
    this.phoneMesErr = false;
    this.phoneMesLenErr = false;
    let key = event.keyCode || event.charCode;
    return key >= 48 && key <= 57;
  }

  displayForBut(event) {
    let key = event.keyCode || event.charCode;
    if (key == 8) {
      this.editPhoneButton = false;
    } else {
      this.editPhoneButton = true;
    }
  }



  isElderlyFunc() {
    let time = new Date(this.updateModel.year + "-" + this.updateModel.month + "-" + this.updateModel.day);
    let age = Date.now() - Number(time);
    let ageGet = Math.floor(age / 1000 / 60 / 60 / 24 / 365.25);
    return ageGet < 18;
  }

  getIpAdress() {
    this.subscription.add(this._http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddress = data.json() }).subscribe());
  }


  onSubmit(navigate) {

    let update = {};
    this.afs.collection('entities').ref.where('uniqueName', '==', this.user.username).limit(1).get().then((data => {
      data.forEach(entity => {
        if (entity.exists) {
          let updatedUser = entity.data();
          updatedUser.username = this.updateModel.username;
          updatedUser.searchTerm = (this.updateModel.username + this.updateModel.firstname + this.updateModel.lastname).toLowerCase();
          updatedUser.uniqueName = this.updateModel.username;
          updatedUser.profileImage = this.user.profileImage;
          updatedUser.name = this.updateModel.firstname + " " + this.updateModel.lastname;
          this.afs.collection('entities').doc(data.docs[0].id).update(updatedUser);
        }

      })
    })).then(() => {

      this.updateModel.birthday = { day: this.updateModel.day, month: this.updateModel.month, year: this.updateModel.year };
      this.afs.collection('users').doc(this.userId).update({
        birthday: this.updateModel.birthday ? this.updateModel.birthday : null,
        username: this.updateModel.username ? this.updateModel.username : null,
        firstname: this.updateModel.firstname ? this.updateModel.firstname : null,
        lastname: this.updateModel.lastname ? this.updateModel.lastname : null,
        email: this.updateModel.email ? this.updateModel.email : null,
        about: this.updateModel.about ? this.updateModel.about : null,
        gender: this.updateModel.gender != 'Cinsiyet Seçin' ? this.updateModel.gender : null,
        job: this.updateModel.job != 'Meslek Seçin' ? this.updateModel.job : null,
        education: this.updateModel.education != 'Eğitim Durumu' ? this.updateModel.education : null,
        city: this.updateModel.city != 'Şehir Seçin' ? this.updateModel.city : null
      });
    })
      .then(() => {
        this.subscription = this.userService.getUser().subscribe(elem => {
          this.lastUser = elem;
        });

        var users = {
          userKey: this.lastUser.$key,
          agreement: this.lastUser.agreement || null,
          birthday: this.dateFormat(new Date(this.lastUser.birthday.year + "/" + this.lastUser.birthday.month + "/" + this.lastUser.birthday.day)),
          totalPoint: this.lastUser.point.totalPoint || null,
          username: this.lastUser.username,
          email: this.lastUser.email,
          firstname: this.lastUser.firstname,
          isEmailVerified: this.lastUser.isEmailVerified || null,
          isSecret: this.lastUser.isSecret || null,
          joinDate: this.dateFormat(new Date(this.lastUser.joinDate)),
          lastname: this.lastUser.lastname,
          level: this.lastUser.level,
          city: this.lastUser.city || null,
          phoneNumber: this.lastUser.phoneNumber || null,
          education: this.lastUser.education || null,
          gender: this.lastUser.gender || null,
          job: this.lastUser.job || null,
          profileImage: this.lastUser.profileImage || null,
          followings: this.lastUser.following ? this.lastUser.following.length : 0,
          followers: this.lastUser.followers ? this.lastUser.followers.length : 0
        }
        this.subscription = this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).subscribe(a => a);
        this.getPoint(navigate)

      }).then(() => {
        this.userService.userLog('profile-update', this.ipAddress);

      });

  }
  dateFormat(data) {
    if (data.length == 10) {
      return data;
    }
    var dd = data.getDate();
    var mm = data.getMonth() + 1; //January is 0!
    var yyyy = data.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }

    data = yyyy + '-' + mm + '-' + dd;
    return data;
  }

  getPoint(navigate) {
    const point = 5;
    let total = 0;
    const userInfoPoints = this.user.userInfoPoints;
    try {
      if (userInfoPoints.birthday == 0 && this.updateModel.birthday) {
        userInfoPoints.birthday = point;
        total = total + point;
      } else if (!this.updateModel.birthday && userInfoPoints.birthday === point) {
        userInfoPoints.birthday = 0;
        total = total - point;
      }
    } catch (e) {
      userInfoPoints.birthday = point;
      total = total + point;
    }
    try {
      if (userInfoPoints.city === 0 && this.updateModel.city !== 'Şehir Seçin') {

        userInfoPoints.city = point;
        total = total + point;
      } else if (this.updateModel.city === 'Şehir Seçin' && userInfoPoints.city === point) {
        userInfoPoints.city = 0;
        total = total - point;
      }
    } catch (e) {
      userInfoPoints.city = point;
      total = total + point;
    }
    try {
      if (userInfoPoints.education === 0 && this.updateModel.education !== 'Eğitim Durumu') {
        userInfoPoints.education = point;
        total = total + point;
      } else if (this.updateModel.education == 'Eğitim Durumu' && userInfoPoints.education == point) {
        userInfoPoints.education = 0;
        total = total - point;
      }
    } catch (e) {
      userInfoPoints.education = point;
      total = total + point;
    }
    try {
      if (userInfoPoints.about == 0 && this.updateModel.about) {
        userInfoPoints.about = point;
        total = total + point;
      } else if (!this.updateModel.about && userInfoPoints.about == point) {
        userInfoPoints.about = 0;
        total = total - point;
      }
    } catch (e) {
      userInfoPoints.about = point;
      total = total + point;
    }
    try {
      if (userInfoPoints.gender == 0 && this.updateModel.gender != 'Cinsiyet Seçin') {
        userInfoPoints.gender = point;
        total = total + point;
      } else if (this.updateModel.gender == 'Cinsiyet Seçin' && userInfoPoints.gender == point) {
        userInfoPoints.gender = point;
        total = total - point;
      }
    } catch (e) {
      userInfoPoints.gender = point;
      total = total + point;
    }
    try {
      if (userInfoPoints.job == 0 && this.updateModel.job != 'Meslek Seçin') {
        userInfoPoints.job = point;
        total = total + point;
      } else if (this.updateModel.job == 'Meslek Seçin' && userInfoPoints.job == point) {
        userInfoPoints.jon = 0;

        total = total - point;
      }
    } catch (e) {
      userInfoPoints.job = point;
      total = total + point;
    }

    this.afs.collection('users').doc(this.userId).update({
      point: {
        totalPoint: this.user.point.totalPoint + total
      }
    }).then(() => {

      this.afs.collection('users').doc(this.userId).update({ userInfoPoints: userInfoPoints });
    })
      .then(() => {
        if (navigate == 'form') {
          if (total >= 0) {
            this.dialog.open(SaveMessageComponent, {
              width: '400px',
              data: {
                message: total != 0 ? "Tebrikler " + total + " puan kazanarak " + this.user.point.totalPoint + " puana yükseldin!"
                  : "Değişiklikler kaydedildi!",
                type: "update"
              }
            });
          } else if (total < 0) {
            this.dialog.open(SaveMessageComponent, {
              width: '400px',
              data: {
                message: total != 0 ? Math.abs(total) + " puan kaybederek " + this.user.point.totalPoint + " puana düştün!"
                  : "Değişiklikler kaydedildi!",
                type: "update"
              }
            });
          }
        }
      });
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/personal-info/personal-info.component.ts